<template>
  <div id="app" :class="skinSign">
    <router-view></router-view>
  </div>

</template>

<script>
  import {mapState, mapGetters, mapMutations} from 'vuex';
  let func=new Promise((resolve,reject)=>{
    if(1){
      resolve()
    }else{
      reject()
    }
  })

export default {
  name: 'App',
  computed:{
    ...mapState(['routers','userInfo','skinSign']),
    ...mapGetters(['getUserSkinSign'])
  }
}
</script>

<style lang="stylus">
html
  min-height 100%
  background #f4f5f6

body #app
  min-height 100%
</style>



// WEBPACK FOOTER //
// src/App.vue